import { createContext, useState } from "react";

interface authInterface {
  accessToken?: string;
  refreshToken?: string;
}

const authStorage = localStorage.getItem("auth");
let auth: any;
if (authStorage && authStorage.length) {
  auth = JSON.parse(authStorage);
}
const AuthContext = createContext({ ...auth });
const AuthProvider = ({ children }: any) => {
  const [authState, setAuthState] = useState<authInterface>(auth);
  const [isLogedIn, setIsLogedIn] = useState(auth ? true : false);

  const setAuth = (data: any) => {
    setAuthState(data);
    setIsLogedIn(true);
    if (data) {
      localStorage.setItem("auth", JSON.stringify(data));
    }

    if (!localStorage.getItem("localization")) {
      // @ts-ignore
      localStorage.setItem(
        "localization",
        JSON.stringify({ language: 1, languageKey: "fa", isRtl: true })
      );
    }
  };

  return (
    <AuthContext.Provider
      value={{ authState, setAuth, isLogedIn, setIsLogedIn }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
